var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAppleCalendarLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    fill: "none",
    viewBox: "0 0 48 49",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 25,
    r: 23.5,
    fill: "#fff",
    stroke: "#E8E8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666A73",
    d: "M32.93 21c.046-.328.07-.662.07-1 0-3.86-3.14-7-7-7-2.478 0-4.766 1.334-6.004 3.416C19.372 16.142 18.698 16 18 16c-2.756 0-5 2.244-5 5 0 .102.002.202.01.3C10.092 22.146 8 24.862 8 28c0 3.86 3.14 7 7 7h18c3.86 0 7-3.14 7-7 0-3.882-3.148-7.032-7.07-7z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAppleCalendarLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Apple_Calendar_logo.f21ca674.svg";
export { ForwardRef as ReactComponent };